import { render } from "./WhySogdoItsOurValuesComp.vue?vue&type=template&id=504c9306&scoped=true"
import script from "./WhySogdoItsOurValuesComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsOurValuesComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsOurValuesComp.vue?vue&type=style&index=0&id=504c9306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504c9306"]])

export default __exports__